import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useServiceProperty } from "../../../hooks/serviceProperty";
import { AppProperty } from "../../../models/Property";
import {
  Container,
  Center,
  Title,
  Button,
  GridContainer,
  ContainerCard,
  CardImage,
  CardTitle,
  ContentCard,
} from './style';
import { LuCircleDashed, LuCheckCircle, LuAlertCircle, LuArchive } from 'react-icons/lu';
import { storageServerPath } from "../../../utils/server/api";

export default function MySpaceProperty() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { fetchProperties } = useServiceProperty();
  const [quotation, setQuotation] = useState(0);

  const [properties, setProperties] = useState<AppProperty[]>([]);

  useEffect(() => {
      fetchProperties().then((data) => {
          setProperties(data);
      });
  }, []);

  if (properties.length === 0) {
    return (
      <Container>
        <Center>
          <Title>{t("empty-properties-warning-1")}</Title>
          <Title style={{marginTop: -10}}>{t("empty-properties-warning-2")}</Title>

          <Button
            onClick={() => navigate("/registerProperty")}
            style={{marginTop: 20}}>{t("register-property")}</Button>
        </Center>
      </Container>
    );
  }

  return (
      <Container>
          <GridContainer>
              {properties.map((p) => {
                let icon = <LuCircleDashed color="white" size={24} />;
                let bg_status = '!border-[#FF0000] bg-[#FF7575]';
                let text = '!text-white';

                if (p.status == 'active' || p.status == "active_certified") {
                    icon = <LuCheckCircle color="#50700F" size={24} />;
                    bg_status = '!border-[#50700F] bg-[#E1E7D6]';
                    text = '!text-[#50700F]';
                } else if (p.status == 'archived') {
                    icon = <LuArchive />;
                    bg_status = '!border-gray-700 bg-gray-300';
                    text = '!text-gray-700';
                } else if (p.status !== 'inactive' && p.status !== 'rejected') {
                    icon = <LuAlertCircle color="white" size={24} />;
                    bg_status = '!border-[#D96900] bg-[#F6C112]';
                    text = '!text-white';
                }

                return (
                  <div className="flex m-[30px] justify-start items-center flex-col !text-black !border-1 !border-[#50700F] !rounded-[20px] max-h-[600px] max-w-[350px] px-[10px] py-[20px] cursor-pointer"
                      onClick={() =>
                          navigate(`/detailsPropertySeller/${p.id as number}`)
                      }
                  >
                      <CardImage
                          src={
                              storageServerPath + p?.file_images?.split(";")[0]
                          }
                      />

                      <ContentCard>
                        <h3
                            className={`!text-[18px] w-full !text-[#50700F] whitespace-normal`}
                        >
                            {/* {lng === "en"
                            ? (p.name_en || "").slice(0, 57)
                            : p.name.slice(0, 57)} */}
                            {p.name}
                      </h3>
                        
                        <p className="!text-[18px] w-full whitespace-pre-line text-ellipsis mb-2.5">
                                {`
                            ${t("credits_available")}: ${
                                p.carbon_credits_available
                                } tCO₂
                            ${t("estimated_value")}: R$${
                                (quotation * p.carbon_credits_available).toFixed(2)
                                }
                            ${t("tons_estimated_value")}: R$${quotation.toFixed(2)}
                            `}
                                {/* {lng === "en"
                                ? (p.description_en || "").slice(0, 80)
                                : (p.description || "").slice(0, 80)} 
                            ...
                                */}
                        </p>
                          <div className={`flex flex-rol gap-2 justify-around items-center ${text} !border-1 ${bg_status} rounded-[5px] w-fit px-2 py-1 mt-10`}>
                            {icon}
                            <p
                                //   className={
                                //       p.status === "active"
                                //           ? "greeText"
                                //           : p.status === "inactive"
                                //           ? "redText"
                                //           : "orangeText"
                                //   }
                            >
                                {t(p.status)}
                            </p>
                          </div>
                      </ContentCard>
                  </div>
              )})}
          </GridContainer>

          <Center>
              <Button
                  onClick={() => navigate("/registerProperty")}
                  style={{ marginTop: 20 }}
              >
                  {t("register-property")}
              </Button>
          </Center>
      </Container>
  );
}
